import React from 'react';
import { motion } from 'framer-motion';
import { now } from '../content';
import { Reveal, RollText } from './Reveal';
import { EASE_OUT } from './motion';

export function Now() {
  return (
    <section id="now" className="now wrap">
      <div className="section-head mono">
        <span>(02)</span>
        <span>Now</span>
      </div>
      <div className="now__grid">
        {now.map((item, i) => (
          <motion.a
            key={item.name}
            className="now__card"
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            data-cursor="Visit"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '0px 0px -10% 0px' }}
            transition={{ duration: 1.1, ease: EASE_OUT, delay: i * 0.12 }}
          >
            <div className="now__top mono">
              <span>{item.label}</span>
              <span className="muted">{item.role}</span>
            </div>
            <h3 className="now__name">
              <Reveal delay={0.1 + i * 0.12}>
                <RollText>{item.name}</RollText>
              </Reveal>
            </h3>
            <p className="now__desc">{item.description}</p>
            <span className="now__cta mono">
              <span className="keep-case">{item.cta}</span> <span className="now__arrow">↗</span>
            </span>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
